export const ExperimentsConsts = {
  WixFormsMigration: 'specs.bookings.WixFormsMigration',
  UseMoment: 'specs.bookings.MyBookingsUseMoment',
  BookFlowSettings: 'specs.bookings.BookFlowSettings',
  BookingsAppSettingsMigration:
    'specs.bookings.bookings-app-settings-migration',
  RemoveSkipPreferencesModalParam:
    'specs.bookings.removeSkipPreferencesModalParam',
};
